import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { IColumns } from './models/columns-model';
import { DataCleanerSearch } from './models/data-cleaner-search.model';
import { IGroupedResults, ISearchResults } from './models/search-results.model';

interface IDCResponse {
  msg: string;
  success: boolean;
  name: string;
}

@Injectable()
export class DataCleanerService {

  numRecordsFound = 0;

  constructor(private http: HttpClient) {
  }

  numRecordsFoundTooMany() {
    return (this.numRecordsFound > 250000);
  }

  loadSearchesForCorporation(): Observable<DataCleanerSearch[]> {
    return this.http.get<DataCleanerSearch[]>(`${ environment.dataCleanerUrl }/dataClean/loadSearchesForCorporation`);
  }

  loadSearchResults(id: string): Observable<ISearchResults> {
    return this.http.get<ISearchResults>(`${ environment.dataCleanerUrl }/dataClean/getResults?searchId=${ id }`).pipe(map(res => {
      const resultsTableData: ISearchResults = res;
      resultsTableData.searchId = id;
      return resultsTableData;
    }));
  }

  getCSV(searchId: string, isCandidate: boolean): Observable<any> {
    return this.http.post(`${ environment.dataCleanerUrl }/dataClean/getCSVExport?searchId=${ searchId }`, {
      candidate: isCandidate
    });
  }

  createTearSheet(searchId: string,
                  row: IGroupedResults,
                  column: IColumns,
                  hotListName: string,
                  isCandidate: boolean): Observable<IDCResponse> {
    return this.http.post<IDCResponse>(`${ environment.dataCleanerUrl }/dataClean/createTearSheet?searchId=${ searchId }`, {
      group: row,
      col: column,
      name: hotListName,
      candidate: isCandidate
    });
  }

  prepareSearch(postObject: any): Observable<any> {
    const response = this.http.post(`${ environment.dataCleanerUrl }/dataClean/prepareSearch`, postObject);
    console.log(response);
    return response;
  }

  calculateTotal(postObject: any): Observable<any> {
    return this.http.post(`${environment.dataCleanerUrl}/dataClean/calculateTotal`, postObject);
  }

  scheduleSearch(searchId: string, postObject: any): Observable<any> {
    return this.http.post(`${environment.dataCleanerUrl}/dataClean/scheduleSearch?searchId=${searchId}`, postObject);
  }

  deleteScheduledSearch(searchId: string): Observable<any> {
    return this.http.delete(`${environment.dataCleanerUrl}/dataClean/deleteSearch?searchId=${searchId}`);
  }

  getSearchResults(searchId: string): Observable<any> {
    return this.http.get(`${environment.dataCleanerUrl}/dataClean/getResults?searchId=${searchId}`);
  }
}
